import * as yup from 'yup';
import { EMPTY_ARRAY, Row, Column, RenderConfig, SelectInput, NumberInput, BOOLEAN_OPTIONS } from 'commons-ui';
import { HomePageWidgetsCategory } from 'commons/models/homePage.model';
import { GAMES, LAYOUT_ORDER, WIDGET_TYPES, WIDTH } from '../../../utils/constants';

export const FORM_FIELD_KEYS = {
	ITEMS: 'items',
	WIDGET_TYPE: 'widgetType',
	WIDTH_INVERSE: 'widthInverse',
	INDEX: 'index',
	SPACE_WIDGET_REQUIRED: 'isSpaceWidgetRequiredBelow'
};

export const validationSchema = yup.object().shape({
	placeholderFor: yup.string().required('Item Placeholder field is required'),
	widgetType: yup.string().when('placeholderFor', {
		is: (placeholder: any) => GAMES.includes(placeholder.toUpperCase()),
		then: (schema) => schema.required(`widgetType is required for ${HomePageWidgetsCategory.GAMES} placeholder`)
	}),
	numOfCols: yup.string().when('placeholderFor', {
		is: (placeholder: any) => GAMES.includes(placeholder.toUpperCase()),
		then: (schema) => schema.required(`numOfCols is required for ${HomePageWidgetsCategory.GAMES} placeholder`)
	}),
	index: yup.number().required('Current Item Order is required')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.ITEMS]: new RenderConfig()
		.setName('placeholderFor')
		.setLabel('Item Placeholder')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: LAYOUT_ORDER
		}),
	[FORM_FIELD_KEYS.WIDGET_TYPE]: new RenderConfig()
		.setName('widgetType')
		.setLabel('Widget Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: WIDGET_TYPES
		}),
	[FORM_FIELD_KEYS.WIDTH_INVERSE]: new RenderConfig()
		.setName('numOfCols')
		.setLabel('Width Occupied')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: WIDTH
		}),
	[FORM_FIELD_KEYS.INDEX]: new RenderConfig()
		.setName('index')
		.setLabel('Current Item Order')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.SPACE_WIDGET_REQUIRED]: new RenderConfig()
		.setName('isSpaceWidgetRequiredBelow')
		.setLabel('Add Space below this widget?')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: BOOLEAN_OPTIONS,
			required: true
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.ITEMS)]),
		new Column([new Row(FORM_FIELD_KEYS.WIDGET_TYPE)]),
		new Column([new Row(FORM_FIELD_KEYS.WIDTH_INVERSE)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.INDEX)]),
		new Column([new Row(FORM_FIELD_KEYS.SPACE_WIDGET_REQUIRED)])
	])
];
